export default __webpack_public_path__ + "static/media/offer2.319f98f2.jpg";